import { engineComponent, Utils } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { WinAnimatorExtended } from "./WinAnimatorExtended";
import { Symbol } from "../GameComponents/Symbol";
import { PaylinesDefinitions } from "../GameComponents/PaylinesDefinitions";
import { CustomUtils } from "../Utils/CustomUtils";
import { Winframes } from "../GameComponents/Winframes";
import { FreespinsView } from "../GameComponents/Freespins/FreespinsView";
import { GameManager } from "../Managers/GameManager";

@engineComponent(ComponentTypes.DisplayObject)
export class WinAnimatorFreespins extends WinAnimatorExtended {
    //******************************************************************************************************************
    // EXPAND WILD FS
    //******************************************************************************************************************

    protected expandWildReelEffect(reelIndex: number) {
        if (FreespinsView["ExpandWildReel" + (reelIndex + 1) + "FS"] != null) {
            FreespinsView["ExpandWildReel" + (reelIndex + 1) + "FS"].goToCase("EXPAND_SPAWN");
        }
    }

    //******************************************************************************************************************
    //  SHOW WINS
    //******************************************************************************************************************

    protected winSymbolsGoToCaseAsPayline(winIndex: number, caseType: string): Array<Symbol> {
        const win = this.currentWins[winIndex];
        const symbols: Array<Symbol> = [];
        const customData = this.getCustomDataResponse();

        if (this.paylines != null) {
            const definition = PaylinesDefinitions.getPaylineDefinitionsById(
                win.paylineId,
                this.paylines.paylineDefinition,
            );

            if (FreespinsView.FSPaylinesIndicator != null) {
                FreespinsView.FSPaylinesIndicator.goToCase("HIDE");
            }

            for (let i = 0; i < definition.length; i++) {
                if (win.mask[i] === 1 && this.allowSymbolGoToCase(i, definition[i], caseType)) {
                    let symbol = this.currentSymbols[i][definition[i]];
                    let symbolsContainer = this.symbolsContainer;
                    if (CustomUtils.NudgeSymbols.indexOf(symbol.id + 1) > -1) {
                        const firstIndex = CustomUtils.getNudgeSymbolIndex(
                            this.symbolCount,
                            this.currentReels[i].transform,
                            symbol.id + 1,
                        );
                        symbol = this.currentSymbols[i][firstIndex];
                        symbolsContainer = this.expandedSymbolsContainer;
                        if (this.elementInstance["Winframes"] != null) {
                            <Winframes>this.elementInstance["Winframes"].winframes[i][definition[i]].goToCase(caseType);
                        }
                    }

                    // show multi wild wins x2 x3
                    if (symbol.id == CustomUtils.SymbolWildMultiply - 1) {
                        if (
                            caseType == Symbol.CaseSingleWin ||
                            caseType == Symbol.CaseWin ||
                            caseType == Symbol.CaseCycle
                        ) {
                            if (!Utils.isNullOrUndefined(customData)) {
                                if (!Utils.isNullOrUndefined(customData.wildSymbols)) {
                                    for (let j: number = 0; j < customData.wildSymbols.length; j++) {
                                        if (customData.wildSymbols[j].type == "multiplier") {
                                            if (this.currentReels != null) {
                                                let multiplier = customData.wildSymbols[j].multiplier;
                                                let reelIndex = customData.wildSymbols[j].reelIndex;
                                                let symbolIndex = customData.wildSymbols[j].symbolIndex;

                                                if (i == reelIndex && definition[i] == symbolIndex) {
                                                    let symbolMulti = this.currentSymbols[reelIndex][symbolIndex];
                                                    symbolMulti.goToCase(
                                                        caseType + "_MULTI_" + multiplier,
                                                        false,
                                                        i * this.winDelay,
                                                        i,
                                                    );
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        } else {
                            if (!Utils.isNullOrUndefined(customData)) {
                                if (!Utils.isNullOrUndefined(customData.wildSymbols)) {
                                    for (let j: number = 0; j < customData.wildSymbols.length; j++) {
                                        if (customData.wildSymbols[j].type == "multiplier") {
                                            if (this.currentReels != null) {
                                                let multiplier = customData.wildSymbols[j].multiplier;
                                                let reelIndex = customData.wildSymbols[j].reelIndex;
                                                let symbolIndex = customData.wildSymbols[j].symbolIndex;

                                                if (i == reelIndex && definition[i] == symbolIndex) {
                                                    let symbolMulti = this.currentSymbols[reelIndex][symbolIndex];
                                                    symbolMulti.goToCase(caseType + "_MULTI_" + multiplier);
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }

                    if (symbol.id != CustomUtils.SymbolWildMultiply - 1) {
                        if (
                            caseType == Symbol.CaseSingleWin ||
                            caseType == Symbol.CaseWin ||
                            caseType == Symbol.CaseCycle
                        ) {
                            symbol.goToCase(caseType, false, i * this.winDelay, i);
                        } else {
                            symbol.goToCase(caseType);
                        }
                    }
                    symbolsContainer.addChild(symbol);
                    symbols.push(symbol);
                }
            }
        }

        return symbols;
    }

    public getDataResponse(): any {
        return GameManager.freespinsResponse;
    }

    public getCustomDataResponse(): any {
        const customData = GameManager.freespinsResponse.customData;
        /*if (!Utils.isNullOrUndefined(customData)) {

        }*/

        return customData;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/WinAnimatorFreespins.ts
 **/